(function(global) {
    'use strict';
  
    var lib = global.lib || (global.lib = {}),
        cjs = global.createjs || (global.createjs = {}),
        mms = global.mms || (global.mms = {});
    
    function Painting() {
        this.__parent__.apply(this, arguments);
        
        this.autoReset = false;
        this.stop();
        
        this.on("added", this._added, this);
    }
    Painting.prototype = {
        _added: function() {
            if (!this.painting) {
                this.painting = this.parent.painting;
                this._addListeners();
            }
        },
        _addListeners: function() {
            mms.state.signals.changePainting.add(this._changePainting, this);
            mms.state.signals.changeTweening.add(this._changeTweening, this);
            mms.state.signals.changeRotated.add(this._changeRotated, this);
        },
        _changePainting: function(prevValue) {
            if (mms.state.painting === 0 && prevValue == this.painting) {
                this._rot0();
            }
        },
        _changeTweening: function(prevValue) {
            if (prevValue === mms.State.TWEEN_SCREEN) {
                if (mms.state.painting === 0) {
                    this.gotoAndStop(0);                    
                }
                else {
                    this.gotoAndStop("rot0");                    
                }
            }
        },
        _changeRotated: function(value) {
            if (this.painting === mms.state.painting) {
                mms.state.setTweening(mms.State.TWEEN_PAINTING);
                this._rotate(value, function() {
                    mms.state.setTweening('');
                });
            }
        },
        _rotate: function(forward, callback) {
            if (forward) {
                this._rot180(callback);
            }
            else {
                this._rot0(callback);
            }
        },
        _rot180: function(callback) {
            this.gotoAndStop("rot0");
            TweenLite.to(this, 1, {
                easel:{frame:this.timeline.resolve("rot180")},
                ease:Linear.easeNone,
                onComplete: callback || function() {}
            });
        },
        _rot0: function(callback) {
            var frame = this.timeline.resolve("rot0");
            if (this.currentFrame != frame) {
                TweenLite.to(this, 1, {
                    easel:{frame: frame},
                    ease:Linear.easeNone,
                    onComplete: callback || function() {}
                });
            }
        }
    };
    
    var Pinch = _.extend({}, cjs.TouchMixin, {
        _addListeners: function() {
            Painting.prototype._addListeners.apply(this, arguments);
            this.initTouch();
        },
        onPinchIn: function(touch1, touch2) {
            if (!mms.state.zoom && mms.state.buttonsEnabled) {
                var midPoint = touch2[0].toPoint().midPoint(touch2[1].toPoint()),
                    zoomRect = mms.state.zoomRect[this.painting];
                mms.state.setZoomPos(this.painting, {x: midPoint.x - zoomRect.x, y: midPoint.y - zoomRect.y});
                mms.state.setZoom(true);
            }
        },
        onPinchOut: function(touch1, touch2) {
            if (mms.state.zoom && mms.state.buttonsEnabled) {
                mms.state.setZoom(false);
            }
        }
    });
    
    lib.Painting1 = cjs.extend2(lib.Painting1, Painting, Pinch);
    lib.Painting2 = cjs.extend2(lib.Painting2, Painting, {
        _addListeners: function() {
            Painting.prototype._addListeners.apply(this, arguments);
            mms.state.signals.changeUV.add(this._changeUV, this);
        },
        _changeUV: function(value) {
            if (this.painting === mms.state.painting) {
                if (value) {
                    mms.state.setTweening(mms.State.TWEEN_PAINTING);
                    this._scan(function() {
                        mms.state.setUV(false);
                        mms.state.setTweening('');
                    });
                }
                else {
                    this.gotoAndStop("rot0");
                }
            }
        },
        _scan: function(callback) {
            this.gotoAndStop("uv");
            var sound = mms.sounds.scan({loop:true});
            var tl = new TimelineLite({onComplete: function() {
                sound.stop();
                if (callback) {
                    callback();
                }
            }});
            tl.to(this, 1.5, {easel:{frame:this.timeline.duration-1}, ease:Linear.easeNone, onComplete: function() {
                sound.stop();
            }});
            tl.to(this, 1.5, {easel:{frame:this.timeline.resolve("uv")}, ease:Linear.easeNone, delay: 3, onStart: function() {
                sound.play();
            }});
        }
    });
    lib.Painting3 = cjs.extend2(lib.Painting3, Painting, _.extend({
        _changeRotated: function(value) {
            if (this.painting === mms.state.painting) {
                mms.state.setTweening(mms.State.TWEEN_PAINTING);
                var self = this;
                if (value) {
                    this._split(function() {
                        self._rotate(value, function() {
                            mms.state.setTweening('');
                        });
                    });
                }
                else {
                    this._rotate(value, function() {
                        //self._split(function() {
                            mms.state.setTweening('');
                        //});
                    });
                }
            }
        },
        _split: function(callback) {
            this.gotoAndStop("joint");
            var tl = new TimelineLite({onComplete: function() {
                if (callback) {
                    callback();
                }
            }});
            tl.to(this, 1, {easel:{frame:this.timeline.resolve("split")}, ease:Linear.easeNone});
            tl.to(this, 0.75, {easel:{frame:this.timeline.resolve("joint")}, ease:Linear.easeNone, delay: 0.5});
        }
    }, Pinch));
    
    mms.Painting = Painting;
  
})(this);